import { render, staticRenderFns } from "./MovementUploadModal.vue?vue&type=template&id=08aa294d&scoped=true&"
import script from "./MovementUploadModal.vue?vue&type=script&lang=js&"
export * from "./MovementUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./MovementUploadModal.vue?vue&type=style&index=0&id=08aa294d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa294d",
  null
  
)

export default component.exports